import { render } from "./buyGpuServer.vue?vue&type=template&id=d634bba4&scoped=true"
import script from "./buyGpuServer.vue?vue&type=script&lang=js"
export * from "./buyGpuServer.vue?vue&type=script&lang=js"

import "./buyGpuServer.vue?vue&type=style&index=0&id=d634bba4&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d634bba4"]])

export default __exports__